module.exports = __webpack_public_path__ + "static/media/focus.f3558bf7.png";